import * as React from 'react';
import { Textarea, CustomSubmitButton, CustomSubmitButtonType, Form } from 'soprasteria-ui-library';

interface IDecisionForm {
    setSelectedStandardPhraseText: React.Dispatch<React.SetStateAction<string | undefined>>;
    selectedStandardPhraseText?: string;
    saveForm: (data: any) => void;
    submitForm: (data: any) => void;
    isSubmittingForm: boolean;
    additionalFormInputs?: React.ReactNode;
    defaultValue?: string;
    isRequired: boolean;
}

export const DecisionForm: React.FunctionComponent<IDecisionForm> = ({
    setSelectedStandardPhraseText,
    selectedStandardPhraseText,
    saveForm,
    submitForm,
    isSubmittingForm,
    additionalFormInputs,
    defaultValue,
    isRequired }) => {

    React.useEffect(() => {
        if (defaultValue) {
            setSelectedStandardPhraseText(defaultValue);
        }
    }, [defaultValue])

    return (
        <Form>
            {
                additionalFormInputs
            }
            <Textarea
                name="text"
                label="Motivering (Valfri text eller Standardfras)"
                defaultValue={selectedStandardPhraseText}
                rows={5}
                required={isRequired}
                onChange={(newValue) => setSelectedStandardPhraseText(newValue)} />
            <div className="text-right">
                <CustomSubmitButton buttonType={CustomSubmitButtonType.alternative} isLoading={isSubmittingForm} onButtonSubmit={saveForm}>Spara motivering och stäng</CustomSubmitButton>
                <CustomSubmitButton isLoading={isSubmittingForm} onButtonSubmit={submitForm}>Skicka</CustomSubmitButton>
            </div>
        </Form>
    )
}